import { PIPELINE_STAGES, STAGE_BY_ID, COMMISSION_STATUSES, QUOTATION_STATUSES } from "@/lib/format";

const REGISTRIES = {
  stage: PIPELINE_STAGES,
  commission: COMMISSION_STATUSES,
  quotation: QUOTATION_STATUSES,
};

export default function StatusBadge({ kind = "stage", value, testid }) {
  let s;
  if (kind === "stage") {
    s = STAGE_BY_ID[value] || { id: value, label: value, color: "#5C6660", bg: "#F2F4F3" };
  } else {
    const list = REGISTRIES[kind] || [];
    s = list.find((x) => x.id === value) || { id: value, label: value, color: "#5C6660", bg: "#F2F4F3" };
  }
  return (
    <span
      data-testid={testid}
      style={{ background: s.bg, color: s.color }}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap"
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}
